export default __webpack_public_path__ + "static/profile-b91e21793f18a4e03dc246d6805b7d88.jpg";